import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

export function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
        <div className="spinner" />
      </div>
    );
  }

  return user ? <>{children}</> : <Navigate to="/login" />;
}

export function CustomerRedirect({ children }: { children: React.ReactNode }) {
  const { user, logout } = useAuth();
  if (user?.role === 'customer') {
    if (user.assigned_chatbot_id) {
      return <Navigate to={`/chatbots/${user.assigned_chatbot_id}?tab=chatbot`} replace />;
    }
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: 'var(--color-bg-primary)' }}>
        <div style={{ background: 'var(--color-bg-white)', borderRadius: '12px', padding: '40px', maxWidth: '420px', width: '100%', textAlign: 'center', boxShadow: 'var(--shadow-sm)' }}>
          <div style={{ width: '48px', height: '48px', borderRadius: '50%', background: 'var(--color-warning-light)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="var(--color-warning)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
              <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
            </svg>
          </div>
          <h2 style={{ fontSize: '20px', fontWeight: 600, color: 'var(--color-text-primary)', margin: '0 0 8px' }}>Account Unavailable</h2>
          <p style={{ fontSize: '14px', color: 'var(--color-text-secondary)', margin: '0 0 24px', lineHeight: 1.5 }}>
            Your assigned chatbot is no longer available. Please contact your administrator for assistance.
          </p>
          <button
            onClick={logout}
            style={{ padding: '10px 24px', background: 'var(--color-primary)', color: 'white', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: 500, cursor: 'pointer' }}
          >
            Log Out
          </button>
        </div>
      </div>
    );
  }
  return <>{children}</>;
}

export function LoginRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
        <div className="spinner" />
      </div>
    );
  }

  if (user) {
    const loginRedirect = user.role === 'customer' && user.assigned_chatbot_id
      ? `/chatbots/${user.assigned_chatbot_id}?tab=chatbot`
      : '/';
    return <Navigate to={loginRedirect} />;
  }

  return <>{children}</>;
}
